// import React, { useState, useEffect, useRef } from 'react';
// import { Document, Page, pdfjs } from 'react-pdf';
// import { useLocation } from 'react-router-dom';
// import { fileFormat } from '../../utils/files';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import { Pagination } from 'antd';
// import { Space } from '../utils/utils';
// import { variables } from '../../utils/variables';
// import '../../theme/global.scss';
// import { IoCloudDownload, IoPrint } from 'react-icons/io5';
// import printJS from 'print-js';
// import { typesFiles } from '../../types/uploaded-data';

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

interface IPViewer {}
const PDFViewer = (props: IPViewer) => {
  // const [file, setFile] = useState(fileFormat);
  // const [numPages, setNumPages] = useState(0);
  // const [pageNumber, setPageNumber] = useState(1);
  // const location = useLocation();
  // const componentRef = useRef();
  // const { code, name, id } = location.state as any;

  // useEffect(() => {
  //   async function getDocument() {
  //     const response = await mapFunctionWithDisplayCode(code, id, name);
  //     setFile(response as File);
  //   }

  //   getDocument();
  // }, [code, id, name]);

  // const handlePrint = (event: any) => {
  //   event.preventDefault();

  //   const url = window.URL.createObjectURL(
  //     new Blob([file], { type: typesFiles.pdf })
  //   );

  //   const content = document.createElement('iframe');
  //   window.open(
  //     URL.createObjectURL(new Blob([file], { type: typesFiles.pdf }))
  //   );
  //   console.log(url);
  //   // printJS(url);
  //   // content?.setAttribute('src', url);
  //   // document.body.appendChild(content);
  //   // content.focus();
  //   // content.contentWindow?.print();

  //   // alert('print');

  //   // const mywindow = window.open('', 'PRINT', 'height=400,width=600');

  //   // if (mywindow) {
  //   //   const link = document.createElement('a');
  //   //   link.href = url;
  //   //   mywindow.document.body.appendChild(link);
  //   //   // mywindow.document.write('</head><body >');
  //   //   // mywindow.document.write('<h1>' + document.title + '</h1>');
  //   //   // mywindow.document.write(document.getElementById(elem).innerHTML);
  //   //   // mywindow.document.write('</body></html>');

  //   //   mywindow.document.close(); // necessary for IE >= 10
  //   //   mywindow.focus(); // necessary for IE >= 10*/

  //   //   mywindow.print();
  //   //   mywindow.close();
  //   // }
  // };
  // const onDocumentLoadSuccess = (props: any) => {
  //   const { numPages } = props;
  //   setNumPages(numPages);
  // };

  // return (
  //   <div>
  //     <Space vertical={variables.verticalSpace} />
  //     <Space vertical={variables.verticalSpace} />
  //     <div className='pdfCommands'>
  //       <IoPrint onClick={handlePrint} />
  //       <Space horizontal={variables.horizontalSpace} />
  //       <IoCloudDownload
  //         onClick={() => mapFunctionWithDownloadCode(code, id, name)}
  //       />
  //     </div>

  //     <Space vertical={variables.verticalSpace} />
  //     <Space vertical={variables.verticalSpace} />
  //     <Document
  //       file={file}
  //       onLoadSuccess={onDocumentLoadSuccess}
  //       className={'pdfViewer'}
  //     >
  //       <Page pageNumber={pageNumber} />
  //     </Document>
  //     <Space vertical={variables.verticalSpace} />

  //     {numPages && (
  //       <Pagination
  //         defaultCurrent={1}
  //         total={numPages}
  //         current={pageNumber}
  //         pageSize={1}
  //         onChange={e => setPageNumber(e)}
  //         style={{
  //           display: 'flex',
  //           justifyContent: 'center'
  //         }}
  //       />
  //     )}
  //     <Space vertical={variables.verticalSpace} />
  //   </div>
  // );
  return null;
};

export default PDFViewer;
